var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userBranches.length > 0)?_c('v-select',{class:_vm.isMobile ? 'selectRoleMobile' : 'selectRole',attrs:{"items":_vm.userBranches,"item-text":"text","item-value":"index"},on:{"change":_vm.setCurrentRole},model:{value:(_vm.currentRoleIndex),callback:function ($$v) {_vm.currentRoleIndex=$$v},expression:"currentRoleIndex"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }